import { LayoutCategory } from '../components/Layout/interface';
import request, { Options } from '../utils/requests/request';

export interface CapiSelfIntroductionRequest {
  appCode: string;
  source: string;
  layoutCategory?: LayoutCategory;
}

export interface CapiSelfIntroduction {
  logo?: string;
  app: {
    introduction: string;
    capiLoanDefaultMsg?: string;
    capiLoanNoOperationMsg?: string;
    openingRemarksMsg?: string;
    voiceUrl?: string;
    avatar?: string;
  };
  fileTypeList?: string[]; // e.g. ['doc','docx','pdf','text']
  isMuteFlag?: 'Y' | 'N';
  isShowCapMsg?: 'Y' | 'N';
  isShowDisclaimer?: 'Y' | 'N';
  isShowThinking?: 'Y' | 'N';
  isShowVoiceButton?: 'Y' | 'N';
}

/**
 * Capi 自我介绍接口
 * POST /ai/capi/self-introduction
 */
export const capiSelfIntroduction = (params: CapiSelfIntroductionRequest, options?: Options) =>
  request.post<CapiSelfIntroduction>('/ai/capi/self-introduction', params, options);
